import ConfigActividades from './ConfigActividades'
import ConfigContactos from './ConfigContactos'
import ConfigFacturas from './ConfigFacturas'

export {
  ConfigActividades,
  ConfigContactos,
  ConfigFacturas
}
